<template>
  <div class="pb-5">
    <nav-bar/>
    <sidebar-toggle-button/>
    <chat-page/>
    <ticket-button/>

    <!-- Sidebar -->
    <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow" v-if="$store.state.isSidebarOpen">
      <ul class="nav flex-column">
        <li class="nav-item">
          <a class="nav-link navbar-text pull-left" href="#/OrderPending">
            {{$t('OrderCurrent.sidebar.pending')}}
          </a>
          <span v-if="pending.length > 0" class="pull-right badge badge-default">{{ pending.length }}</span>
        </li>
        <li class="nav-item" id="current">
          <a class="nav-link navbar-text pull-left" href="#/OrderCurrent">
            {{$t('OrderCurrent.sidebar.current')}}
          </a>
        </li>
        <li class="nav-item" :class="{'current': $route.query.newNote}">
          <router-link :to="{name: 'OrderCurrent', query: {newNote: true}}" class="nav-link navbar-text pull-left pr-0">
            {{$t('OrderCurrent.sidebar.notes')}}
          </router-link>
          <span v-if="computed_newCount.newNote > 0" class="pull-right badge badge-default">{{ computed_newCount.newNote }}</span>
        </li>
        <li class="nav-item" :class="{'current': $route.query.newDate}">
          <router-link :to="{name: 'OrderCurrent', query: {newDate: true}}" class="nav-link navbar-text pull-left pr-0">
            {{$t('OrderCurrent.sidebar.date')}}
          </router-link>
          <span v-if="computed_newCount.newDate > 0" class="pull-right badge badge-default">{{ computed_newCount.newDate }}</span>
        </li>
        <li class="nav-item" :class="{'current': view.query.name === $route.query.name}" v-for="(view, index) in customViews" :key="index">
          <router-link :to="{name: 'OrderCurrent', query: view.query}" class="nav-link navbar-text pull-left">
            {{view.query.name}}
          </router-link>
        </li>
        <li class="nav-item" v-if="isAdmin">
          <!-- <a class="nav-link navbar-text pull-left" href="" @click.prevent="modal.newCustomView = true">
            {{$t('OrderCurrent.sidebar.add_custom_view')}}
          </a> -->
          <button class="btn btn-sm btn-kne-orange" @click.prevent="modal.newCustomView = true">
            <i class="fa fa-plus fa-lg" aria-hidden="true"></i>
          </button>
          <button class="btn btn-sm btn-kne-orange" @click.prevent="modal.deleteCustomView = true">
            <i class="fa fa-minus fa-lg" aria-hidden="true"></i>
          </button>
        </li>
      </ul>
      <button id="addOrder" class="btn btn-kne-orange col-12 my-3" @click="openNewOrder()">
        {{$t('OrderPending.sidebar.add_order')}}
        <i class="fa fa-plus-circle fa-lg" aria-hidden="true"></i>
      </button>
    </div>

    <!-- Order status Counter -->
    <order-status-counter
      class="mx-2 mt-5"
      :filterResults="filterResults"
      :processedArray="processing"
      @updatedNewCount="computed_newCount">
    </order-status-counter>

    <table-element
      :isShowFilter="true"
      :title="$t('OrderCurrent.title')"
      :fields="fieldsObj"
      :arrOfElement="processing"
      :sortSpacing="4"
      :isShowSelectAll="true"
      class="card mx-2 my-4"
      @updateFilterResults="updateFilterResults"
      @updateSelectedOrders="updateSelectedOrders"
    >
      <template #header-actions>
        <p v-show="!shortDispatch && !quickEdit" class="red-text mb-0">{{feedbackMessage}}</p>
        <button :disabled="selected.length < 1" @click="openDispatch(); clearfeedbackMessage()" class="m-1 btn btn-kne-orange" >{{$t('OrderCurrent.actions.shortDispatch')}}</button>
        <button v-if="$store.state.userInfo && isSageOne" :disabled="selected.length < 1" @click="openBilling()" class="m-1 btn btn-kne-orange">{{$t('OrderCurrent.actions.billing')}}</button>
        <button v-if="$store.state.userInfo && isQuickBook" :disabled="selected.length < 1" @click="openBilling()" class="m-1 btn btn-kne-orange">{{$t('OrderCurrent.actions.billing')}}</button>
        <button :disabled="selected.length < 1" @click="openQuickEdit(); clearfeedbackMessage()" class="m-1 btn btn-kne-orange">{{$t('OrderCurrent.actions.quickEdit')}}</button>
        <button :disabled="selected.length < 1" @click="openStatusEdit();" class="m-1 btn btn-kne-orange">{{$t('OrderCurrent.actions.quick_status')}}</button>
        <button :disabled="selected.length < 1" @click="openVinPrinting(); clearfeedbackMessage()" class="m-1 btn btn-kne-orange">{{$t('OrderCurrent.actions.printVin')}}</button>
        <custom-json-excel
          class="btn btn-kne-orange pull-right"
          v-if="isAdmin"
          :filterResults="filterResults"
          :customerFields="customers_fields"
          :name="'order_current_' + getDate(Date.now()) + '.xls'"
          />
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(order, index) in content.results"
        class="table-element_hover text-center"
        :key="order['.key']"
        :class="{
          'drop': order.status === 'Drop',
          'cancel': order.status === 'Cancel',
          'waiting': order.status === 'Attente',
          'pick': order.status === 'Pick',
          'transit': order.status === 'Transit',
          'dispatch': order.status === 'Dispatch',
          'reject': order.status === 'Reject',
          'inspection': order.status === 'Inspection',
          'transfered': order.status === 'Transférée'
          }">
          <td class="pt-2">
            <label class="custom-control custom-checkbox my-2 ml-2 mr-0">
              <input :value="order['.key']" v-model="selected" type="checkbox" class="custom-control-input">
              <span class="custom-control-indicator"></span>
            </label>
          </td>
          <td class="pt-2">
            <router-link :to="{name: 'OrderInfo', query: {orderId: order['.key']}}">
              <input type="button" class="btn btn-kne-orange" :value="$t('OrderCurrent.view')">
            </router-link>
          </td>
          <td v-if="!isDateRoute" class="pt-2">
            <a :href="order.invoice" target="_blank" @click="print(order)">
              <!-- <input type="button" class="btn btn-kne-orange pull-right" :value="$t('OrderCurrent.view')"> -->
              <button class="btn btn-kne-orange" :class="{'printed': order.isPrinted}">
              <!-- <button class="btn btn-kne-orange pull-right" :class="{'printed': !order.isPrinted}"> -->
                <i class="fa fa-print" aria-hidden="true"></i>
              </button>
            </a>
          </td>

          <td v-if="order.docs" class="pt-2">
            <i class="fa fa-file mt-2" aria-hidden="true"></i>
          </td>
            <td v-if="!order.docs" class="pt-2">
              <input v-if="checkDate(order.dateSignataire)" type="button" class="btn btn-kne-green" :value="calcBusinessDays(order.dateSignataire)">
              <input v-if="!checkDate(order.dateSignataire)" type="button" class="btn btn-kne-red" :value="calcBusinessDays2(order.dateSignataire)">
            </td>
          <td v-if="isDateRoute">
              <input v-if="checkDate(order.datePromis)" type="button" class="btn btn-kne-red" :value="calcBusinessDays(order.datePromis)">
              <input v-if="!checkDate(order.datePromis)" type="button" class="btn btn-kne-green" :value="calcBusinessDays2(order.datePromis)">
          </td>
          <td class="pt-3">
            <hover-tool-tip
              v-if="order.survey"
              :text="getOrderSurvey(order.survey)"
              :iconColor="getSurveyIconColor(order.survey)"
              :displayFixed="true"
              bottom
              right
            />
          </td>
          <td class="nowrap pt-3">{{order['.key']}}
            <hover-tool-tip
              :text="`<div>
                        ${order.source || '-'}
                        <br>${getDate(order.creationDate) || '-'}
                        <br>${order.make || '-'} ${order.model || '-'} ${order.year || '-'}
                      </div>`"
              :top="true"
              :right="true"
              clickable
            />
            <hover-tool-tip
              v-if="order.historySync"
              :text="dispatchHistToolTip(order)"
              :iconText="getOrderHistoryLength(order)"
              :top="true"
              :right="true"
            />
          </td>
          <!-- <td v-if="hasIntegration" class="nowrap">
            <i v-if="order.isDivisionX" class="fa fa-check" aria-hidden="true"></i>
          </td> -->
          <td class="nowrap pt-3">{{order.numRef || '-'}}</td>
          <!-- <td class="nowrap"><p class="table-fix-width">{{order.source}}</p></td> -->
          <td class="nowrap pt-3">{{order.vin || '-'}}</td>
          <td class="nowrap pt-3">{{order.model || '-'}}</td>
          <td v-if="isDateRoute" class="nowrap pt-3">{{ order.datePromis }}</td>
          <!-- <td class="nowrap">{{ getDate(order.creationDate) }}</td> -->
          <td class="nowrap pt-3">
            <span>{{ shortenString(order.transmitterName) || '-'}}
              <hover-tool-tip
                :text="`<div>${order.transmitterAddress || '-'} ${order.transmitterCity || '-'}
                          <br>${order.transmitterProvince || '-'} ${order.transmitterPostcode || '-'}, ${order.transmitterCountry || '-'}
                        </div>`"
                :left="true"
                :top="true"
                clickable
              />
            </span>
          </td>
          <td class="nowrap pt-3">
            <span>{{ shortenString(order.receiverName) || '-'}}
              <hover-tool-tip
                :text="`<p>${order.receiverAddress || '-'} ${order.receiverCity || '-'}
                          <br>${order.receiverProvince || '-'} ${order.receiverPostcode || '-'}, ${order.receiverCountry || '-'}
                        </p>`"
                :left="true"
                :top="true"
                clickable
              />
            </span>
          </td>
          <td class="nowrap pt-3">
            <p class="table-fix-width">{{ shortenString(order.payerName) || '-' }}</p>
          </td>
          <td class="nowrap pt-3">
            <span v-if="order.status === 'Dispatch'">{{$t('Search.status.dispatch')}}</span>
            <span v-if="order.status === 'Processing'">{{$t('Search.status.processing')}}</span>
            <span v-if="order.status === 'Pick'">{{$t('Search.status.pick')}}</span>
            <span v-if="order.status === 'Attente'">{{$t('Search.status.waiting')}}</span>
            <span v-if="order.status === 'Transit'">{{$t('Search.status.transit')}}</span>
            <span v-if="order.status === 'Drop'">{{$t('Search.status.drop')}}</span>
            <span v-if="order.status === 'Cancel'">{{$t('Search.status.canceled')}}</span>
            <span v-if="order.status === 'Terminée'">{{$t('Search.status.finished')}}</span>
            <span v-if="order.status === 'Transférée'">{{$t('Search.status.transfered')}}</span>
            <span v-if="order.status === 'Reject'">{{$t('Search.status.rejected')}}</span>
            <span v-if="order.status === 'Inspection'">{{$t('Search.status.inspection')}}</span>
            <hover-tool-tip
              v-if="order.notes"
              :text="getOrderNotes(order.notes)"
              :left="true"
              :top="true"
              :clickable="false"
            />
          </td>
          <td class="nowrap pt-3"><p class="table-fix-width">{{order.driverName || '-'}}</p></td>
        </tr>
      </template>

      <template #body-content-mobile="content">
        <div class="card my-3 mx-2" v-for="(order) in content.results"
        :key="order['.key']"
        :class="{
          'drop': order.status === 'Drop',
          'cancel': order.status === 'Cancel',
          'waiting': order.status === 'Attente',
          'pick': order.status === 'Pick',
          'transit': order.status === 'Transit',
          'dispatch': order.status === 'Dispatch',
          'reject': order.status === 'Reject',
          'inspection': order.status === 'Inspection'
        }">
          <div style="display: flex;">
            <label class="custom-control custom-checkbox form-control-lg mt-1 ml-2" id="checkBox">
              <input :value="order['.key']" v-model="selected" type="checkbox" class="custom-control-input">
              <span class="custom-control-indicator form-control-lg"></span>
            </label>
            <div v-if="order.docs" id="fileIcon">
                <i class="fa fa-file" aria-hidden="true"></i>
            </div>
          </div>

          <div class="card-header m-2">
            <h4>{{order['.key']}}</h4>
            <h6 v-if="isDateRoute"><i class="fa fa-calendar"></i>{{ order.datePromis }}</h6>
            <h6><i class="fa fa-calendar"></i>{{ getDate(order.creationDate) }}</h6>
            <h6 v-if="order.status === 'Dispatch'"><i class="fa fa-exclamation"></i>{{$t('Search.status.dispatch')}}</h6>
            <h6 v-if="order.status === 'Processing'"><i class="fa fa-exclamation"></i>{{$t('Search.status.processing')}}</h6>
            <h6 v-if="order.status === 'Pick'"><i class="fa fa-exclamation"></i>{{$t('Search.status.pick')}}</h6>
            <h6 v-if="order.status === 'Waiting'"><i class="fa fa-exclamation"></i>{{$t('Search.status.waiting')}}</h6>
            <h6 v-if="order.status === 'Transit'"><i class="fa fa-exclamation"></i>{{$t('Search.status.transit')}}</h6>
            <h6 v-if="order.status === 'Drop'"><i class="fa fa-exclamation"></i>{{$t('Search.status.drop')}}</h6>
            <h6 v-if="order.status === 'Cancel'"><i class="fa fa-exclamation"></i>{{$t('Search.status.canceled')}}</h6>
            <h6 v-if="order.status === 'Terminée'"><i class="fa fa-exclamation"></i>{{$t('Search.status.finished')}}</h6>
            <h6 v-if="order.status === 'Transférée'"><i class="fa fa-exclamation"></i>{{$t('Search.status.transfered')}}</h6>
            <h6 v-if="order.status === 'Reject'"><i class="fa fa-exclamation"></i>{{$t('Search.status.rejected')}}</h6>
            <h6 v-if="order.status === 'Inspection'"><i class="fa fa-exclamation"></i>{{$t('Search.status.inspection')}}</h6>
          </div>

          <h6 v-if="!order.docs"> </h6>
          <div class="m-2" v-if="isDateRoute">
            <input v-if="checkDate(order.datePromis)" type="button" class="btn btn-kne-red" :value="calcBusinessDays(order.datePromis)">
            <input v-if="!checkDate(order.datePromis)" type="button" class="btn btn-kne-green" :value="calcBusinessDays2(order.datePromis)">
          </div>

          <div class="m-2">
            <h6>
              <span><i class="fas fa-tools"></i>{{order.make}}</span>
              <span>| <i class="fa fa-car"></i>{{order.model}}</span>
              <span>| <i class="fas fa-calendar-alt"></i>{{order.year}}</span>
            </h6>
            <h6><i class="fa fa-user"></i>{{order.driverName}}</h6>
            <h6><i class="fa fa-home"></i>{{order.transmitterName}}</h6>
            <h6><i class="fa fa-truck"></i>{{order.receiverName}}</h6>
            <h6><i class="fa fa-credit-card"></i>{{order.payerName}}</h6>
          </div>

          <div id="action">
            <router-link :to="{name: 'OrderInfo', query: {orderId: order['.key']}}">
              <input type="button" class="btn btn-kne-orange m-2" :value="$t('OrderCurrent.view')">
            </router-link>
            <div v-if="!isDateRoute">
              <a :href="order.invoice" target="_blank" @click="print(order)">
                <button class="btn btn-kne-orange m-2" :class="{'printed': order.isPrinted}">
                  <i class="fa fa-print" aria-hidden="true"></i>
                </button>
              </a>
            </div>
          </div>
        </div>
      </template>
    </table-element>

    <loading-render v-if="isLoading" />

    <!-- Modal Actions -->
    <transition name="fade">
      <!-- Billing -->
      <modal
        v-if="billing"
        :title="$t('OrderCurrent.actions.billing')"
        @close-request="billing = false; clear()"
        closable
      >
        <table-element
          :isShowFilter="true"
          :title="$t('OrderCurrent.modal.selected_orders')"
          :fields="fieldsObjBIL"
          :arrOfElement="selectedFull"
          :sortSpacing="0"
          class="card mx-2 mt-4"
        >
          <template #header-actions>
            <p class="m-2 mb-0 mt-2">{{$t('OrderCurrent.count')}} {{selected.length}}</p>
          </template>

          <template #pre-body-content>
            <div class="m-2">
              <label for="spreadDate">{{$t('OrderCurrent.modal.billing.date_label')}}</label>
              <!-- <regular-input
              id="spreadDate"
              :value="spreadDate"
              @input="spreadDate = formatDate($event)"
              type="date" :placeholder="$t('OrderCurrent.billingDate')"/> -->
              <custom-date-pick
                :displayFormatPRP="'YYYY-MM-DD'"
                :formatPRP="'YYYY/MM/DD'"
                :pickTimePRP="false"
                :use12HourClockPRP="false"
                :hasInputElement="true"
                @updateDatePick="updateDatePick"
              />
              <button class="mt-1 btn btn-kne-orange" @click="applyBillingDateToAll(spreadDate)">{{$t('OrderCurrent.sameBillingDate')}}</button>
            </div>
          </template>

          <template #body-content-desktop="content">
            <!-- List of orders -->
            <tr v-for="(order, index) in content.results"
            class="table-element_hover text-center"
            :key="index"
            :class="{
              'drop': order.status === 'Drop',
              'cancel': order.status === 'Cancel',
              'waiting': order.status === 'Attente',
              'pick': order.status === 'Pick',
              'transit': order.status === 'Transit',
              'dispatch': order.status === 'Dispatch',
              'reject': order.status === 'Reject',
              'inspection': order.status === 'Inspection',
              'transfered': order.status === 'Transférée'
              }">
              <td class="pt-2">
                <span class="nowrap">
                  {{ order.orderNumber }}
                  <hover-tool-tip
                  :text="`<div>
                            ${order.source || '-'}
                            <br>${getDate(order.creationDate) || '-'}
                            <br>${order.make || '-'} ${order.model || '-'} ${order.year || '-'}
                          </div>`"
                  :top="true"
                  :right="true"
                  clickable
                  />
                </span>
              </td>
              <td class="nowrap">
                <span>
                  {{shortenString(order.payerName)}}
                  <hover-tool-tip
                  :text="`<div>
                            <p>
                              ${order.transmitterAddress || '-'} ${order.transmitterCity || '-'}, ${order.transmitterProvince || '-'} ${order.transmitterPostcode || '-'}, ${order.transmitterCountry || '-'}
                            </p>
                            ->
                            <p>
                              ${order.receiverAddress || '-'} ${order.receiverCity || '-'}, ${order.receiverProvince || '-'} ${order.receiverPostcode || '-'}, ${order.receiverCountry || '-'}
                            </p>
                          </div>`"
                  right
                  :top="true"
                  clickable
                  />
                </span>
              </td>
              <td>
                {{order.numRef}}
              </td>
              <td v-if="sageOneCheck">
                <i v-if="order.sageID && order.sageID !== ''" class="fa fa-check" aria-hidden="true"></i>
              </td>
              <td>
                <regular-input
                min="0"
                :value="order.price"
                @input="order.price = $event"
                type="number" :placeholder="$t('OrderCurrent.price')"/>
              </td>
              <td>
                <regular-input
                  min="0"
                  :value="order.fuelCharge"
                  @input="order.fuelCharge = $event"
                  type="number" placeholder="Fuel Charge"/>
              </td>
              <td>
                <regular-select
                :value="order.taxes"
                @change="order.taxes = $event"
                :placeholder="$t('OrderInfo.modal.tax')">
                  <option v-for="province in $store.state.provinces" :value="province">{{province}}</option>
                </regular-select>
              </td>
              <td>
                <regular-input
                :value="order.taxesComment"
                @input="order.taxesComment = $event"
                type="text" :placeholder="$t('OrderCurrent.taxescomment')"/>
              </td>
              <td>
                <regular-input
                :value="order.billingDate"
                @input="order.billingDate = formatDate($event)"
                type="date" :placeholder="$t('OrderCurrent.billingDate')"/>
              </td>
            </tr>
          </template>

          <template #post-body-content>
            <div class="flex-row my-2" key="post-body-content">
              <div>
                <button v-if="isQuickBook" @click="onSaveBillingOrder()" class="btn btn-kne-orange m-1">{{$t('General.save')}}</button>
                <button v-if="isQuickBook" @click="onFinishBilling()" class="btn btn-kne-orange m-1">{{$t('General.finish')}}</button>
              </div>

              <div>
                <custom-json-excel
                  v-if="isQuickBook"
                  class="btn btn-kne-orange float-right m-1"
                  :filterResults="selectedFull2"
                  :customerFields="billingFields"
                  :name="'order_current_' + getDate(Date.now()) + '.xls'"
                  />
                <a v-if="isSageOne" target="_blank" :href="'https://www.sageone.com/oauth2/auth/central?filter=apiv3.1&response_type=code&client_id=3ff1477e6ec457b7df62&redirect_uri=https://systems.keepneye.com/api4/SageoneToken&scope=full_access&state=' + allOrderID ">
                  <button :disabled="!allBillingFieldCompleted" @click="saveBilling(); clearSelected(); billing = false; clear()" class="btn btn-kne-orange m-1 float-right">{{$t('OrderCurrent.modal.confirm')}}</button>
                </a>
                <button @click="billing = false; clear()" class="btn btn-danger float-right m-1">{{$t('OrderCurrent.modal.cancel')}}</button>
              </div>
            </div>
          </template>
        </table-element>
      </modal>

      <!-- Quick Edit -->
      <modal
        v-if="quickEdit"
        :title="$t('OrderCurrent.actions.quickEdit')"
        @close-request="quickEdit = false; clear()"
        closable
      >
        <table-element
          :isShowFilter="false"
          :title="$t('OrderCurrent.modal.selected_orders')"
          :fields="fieldsObjEDI"
          :arrOfElement="selectedFull"
          :sortSpacing="0"
          class="card mx-2 mt-4"
        >
          <template #header-actions>
            <!-- <p class="text-center red-text">{{$t('OrderCurrent.modal.quick_edit.required_field_process')}}</p> -->
            <p class="m-2 mb-0 mt-2">{{$t('OrderCurrent.count')}} {{selected.length}}</p>
          </template>

          <template #body-content-desktop="content">
            <!-- List of orders -->
            <tr v-for="(order, index) in content.results"
            class="table-element_hover text-center"
            :key="index"
            :class="{
              'drop': order.status === 'Drop',
              'cancel': order.status === 'Cancel',
              'waiting': order.status === 'Attente',
              'pick': order.status === 'Pick',
              'transit': order.status === 'Transit',
              'dispatch': order.status === 'Dispatch',
              'reject': order.status === 'Reject',
              'inspection': order.status === 'Inspection',
              'transfered': order.status === 'Transférée'
              }">
              <td>
                {{order.orderNumber}}
              </td>
              <td>
                <regular-input
                  :value="order.source"
                  @input="order.source = $event"
                  type="text" :placeholder="$t('OrderCurrent.source')"/>
              </td>
              <td>
                <regular-input
                  :value="order.numRef"
                  @input="order.numRef = $event"
                  type="text" :placeholder="$t('OrderInfo.modal.reference')"/>
              </td>
              <td>
                <regular-input
                  :value="order.note"
                  @input="order.note = $event; feedbackMessage = ''"
                  type="text" :placeholder="$t('CreateNote.reason_for_edit')"/>
              </td>
            </tr>
          </template>

          <template #body-content-mobile="content">
            <!-- List of orders -->
            <div
              v-for="(order) in content.results"
              class="card my-3 mx-2"
              :key="order.orderNumber"
              :class="{
              'drop': order.status === 'Drop',
              'cancel': order.status === 'Cancel',
              'waiting': order.status === 'Attente',
              'pick': order.status === 'Pick',
              'transit': order.status === 'Transit',
              'dispatch': order.status === 'Dispatch',
              'reject': order.status === 'Reject',
              'inspection': order.status === 'Inspection'
            }">
              <div class="card-header m-1">
                {{order.orderNumber}}
              </div>
              <div class="m-1">
                <div>
                  <span>
                    {{$t('OrderCurrent.source')}}
                    <regular-input
                      min="0"
                      :value="order.source"
                      @input="order.source = $event"
                      type="text" :placeholder="$t('OrderCurrent.source')"/>
                  </span>
                </div>
                <div>
                  <span>
                    {{$t('OrderInfo.modal.reference')}}
                    <regular-input
                      min="0"
                      :value="order.numRef"
                      @input="order.numRef = $event"
                      type="text" :placeholder="$t('OrderInfo.modal.reference')"/>
                  </span>
                </div>
              </div>
            </div>
          </template>

          <template #post-body-content>
            <div class="mt-2">
              <p class="mx-2 red-text text-right">{{feedbackMessage}}</p>
              <button @click="onQuickEditAction()" class="float-right btn btn-kne-orange m-2">{{$t('OrderCurrent.modal.confirm')}}</button>
              <button @click="quickEdit = false;  clear()" class="float-right btn btn-danger m-2">{{$t('OrderCurrent.modal.cancel')}}</button>
            </div>
          </template>

        </table-element>
      </modal>

      <!-- Print vin -->
      <modal
        v-if="vinPrinting"
        :title="$t('OrderCurrent.modal.printVin.title')"
        @close-request="vinPrinting=false; clear()"
        closable
      >
        <table-element
          :title="$t('OrderCurrent.modal.selected_orders')"
          :arrOfElement="selectedFull"
          :fields="fieldsObjVIN"
          :isShowFilter="false"
          :isShowSelectAll="false"
          :sortSpacing="0"
          :id="'vinPrint'"
          class="mx-2 mt-4"
        >

          <template #header-actions>
            <p class="m-2 mb-0 mt-2">{{$t('OrderCurrent.count')}} {{selected.length}}</p>
          </template>

          <template #pre-body-content>
          </template>

          <template #body-content-desktop="content">
            <!-- List of orders -->
            <tr v-for="(order, index) in content.results"
            class="table-element_hover text-center"
            :key="index">
              <td>
                {{order.orderNumber}}
              </td>
              <td>
                <barcode :value="order.vin" format="CODE128A" >
                  {{$t('OrderCurrent.modal.printVin.noVin')}}
                </barcode>
              </td>
            </tr>
          </template>

          <template #post-body-content>
            <div class="mt-2">
              <button class="btn btn-kne-orange float-right m-1" @click="sendToPrint()">{{$t('OrderCurrent.actions.printVin')}}</button>
            </div>
          </template>

        </table-element>
      </modal>

      <!-- New Order creation -->
      <new-order-modal
        v-if="isNewOrderModal"
        :isNewOrderModal="isNewOrderModal"
        :order="order"
        :addressbook="addressbook"
        @closeNewOrderModal="clear"
      />

      <!-- New View Creation -->
      <modal
        v-if="modal.newCustomView"
        :title="$t('OrderCurrent.sidebar.add_custom_view')"
        @close-request="modal.newCustomView = false; clear()"
        closable
      >
        <div class="container-fluid">
          <div class="row">
            <regular-input
            :value="newCustomView.name"
            @input="newCustomView.name = $event"
            type="text" :placeholder="$t('OrderCurrent.modal.name')" class="col-12 form-group"/>
            <regular-input
            :value="newCustomView.VIN"
            @input="newCustomView.VIN = $event"
            type="text" :placeholder="$t('Search.VIN')" class="col-12 form-group"/>
            <regular-input
            :value="newCustomView.referenceNumber"
            @input="newCustomView.referenceNumber = $event"
            type="text" :placeholder="$t('Search.reference')" class="col-12 col-sm-6 form-group"/>
            <regular-input
            :value="newCustomView.source"
            @input="newCustomView.source = $event"
            type="text" :placeholder="$t('Search.source')" class="col-12 col-sm-6 form-group"/>
            <regular-input
            :value="newCustomView.pickup"
            @input="newCustomView.pickup = $event"
            type="text" :placeholder="$t('Search.pickup')" class="col-12 col-sm-6 form-group"/>
            <regular-input
            :value="newCustomView.delivery"
            @input="newCustomView.delivery = $event"
            type="text" :placeholder="$t('Search.delivery')" class="col-12 col-sm-6 form-group"/>
            <regular-input
            :value="newCustomView.billing"
            @input="newCustomView.billing = $event"
            type="text" :placeholder="$t('Search.billing')" class="col-12 col-sm-6 form-group"/>
            <regular-select
            :value="newCustomView.status"
            @change="newCustomView.status = $event"
            :placeholder="$t('Search.status.status')" class="col-12 col-sm-6 form-group">
              <option value="Dispatch">{{$t('Search.status.dispatch')}}</option>
              <option value="Pick">{{$t('Search.status.pick')}}</option>
              <option value="Transit">{{$t('Search.status.transit')}}</option>
              <option value="Drop">{{$t('Search.status.drop')}}</option>
              <option value="Cancel">{{$t('Search.status.canceled')}}</option>
              <option value="Terminée">{{$t('Search.status.finished')}}</option>
              <option value="Transférée">{{$t('Search.status.transfered')}}</option>
              <option value="Reject">{{$t('Search.status.rejected')}}</option>
              <option value="Inspection">{{$t('Search.status.inspection')}}</option>
              <option value="Attente">{{$t('Search.status.waiting')}}</option>
            </regular-select>
            <regular-datalist-driver
            :value="newCustomView.driver"
            @input="newCustomView.driver = $event.value"
            :secondList="liste"
            :placeholder="$t('Search.driver')" class="col-12 col-sm-6 form-group"/>
            <regular-select
            :value="newCustomView.provincePick"
            @change="newCustomView.provincePick = $event"
            :placeholder="$t('OrderCurrent.modal.provinceOrigin')" class="col-12 col-sm-6 form-group">
              <option value="AB">{{$t('OrderCurrent.province.AB')}}</option>
              <option value="BC">{{$t('OrderCurrent.province.BC')}}</option>
              <option value="MB">{{$t('OrderCurrent.province.MB')}}</option>
              <option value="NB">{{$t('OrderCurrent.province.NB')}}</option>
              <option value="NL">{{$t('OrderCurrent.province.NL')}}</option>
              <option value="NS">{{$t('OrderCurrent.province.NS')}}</option>
              <option value="NT">{{$t('OrderCurrent.province.NT')}}</option>
              <option value="NU">{{$t('OrderCurrent.province.NU')}}</option>
              <option value="ON">{{$t('OrderCurrent.province.ON')}}</option>
              <option value="PE">{{$t('OrderCurrent.province.PE')}}</option>
              <option value="QC">{{$t('OrderCurrent.province.QC')}}</option>
              <option value="SK">{{$t('OrderCurrent.province.SK')}}</option>
              <option value="YT">{{$t('OrderCurrent.province.YT')}}</option>
            </regular-select>
            <regular-select
            :value="newCustomView.provinceDrop"
            @change="newCustomView.provinceDrop = $event"
            :placeholder="$t('OrderCurrent.modal.provinceArrival')" class="col-12 col-sm-6 form-group">
              <option value="AB">{{$t('OrderCurrent.province.AB')}}</option>
              <option value="BC">{{$t('OrderCurrent.province.BC')}}</option>
              <option value="MB">{{$t('OrderCurrent.province.MB')}}</option>
              <option value="NB">{{$t('OrderCurrent.province.NB')}}</option>
              <option value="NL">{{$t('OrderCurrent.province.NL')}}</option>
              <option value="NS">{{$t('OrderCurrent.province.NS')}}</option>
              <option value="NT">{{$t('OrderCurrent.province.NT')}}</option>
              <option value="NU">{{$t('OrderCurrent.province.NU')}}</option>
              <option value="ON">{{$t('OrderCurrent.province.ON')}}</option>
              <option value="PE">{{$t('OrderCurrent.province.PE')}}</option>
              <option value="QC">{{$t('OrderCurrent.province.QC')}}</option>
              <option value="SK">{{$t('OrderCurrent.province.SK')}}</option>
              <option value="YT">{{$t('OrderCurrent.province.YT')}}</option>
            </regular-select>
            <regular-input
            :value="newCustomView.dateReceptionMin"
            @input="newCustomView.dateReceptionMin = $event"
            type="date" placeholder="Date min" class="col-12 col-sm-6 form-group"/>
            <regular-input
            :value="newCustomView.dateReceptionMax"
            @input="newCustomView.dateReceptionMax = $event"
            type="date" placeholder="Date max" class="col-12 col-sm-6 form-group"/>
            <regular-input
            :value="newCustomView.afterXDays"
            @input="newCustomView.afterXDays = $event"
            type="number" :placeholder="$t('OrderCurrent.modal.after_x_days')" class="col-12 col-sm-6 form-group"/>
            <regular-input
            :value="newCustomView.beforeXDays"
            @input="newCustomView.beforeXDays = $event"
            type="number" :placeholder="$t('OrderCurrent.modal.before_x_days')" class="col-12 col-sm-6 form-group"/>
            <!-- <regular-input-no-special class="col-12 col-sm-6 form-group"/> -->
            <div class="col-12">
              <button class="btn btn-kne-orange w-100 mb-2" :disabled="newCustomView.name === ''" @click="addCustomView()">
                {{$t('OrderCurrent.modal.confirm')}}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <!-- View Deletion -->
      <modal
        v-if="modal.deleteCustomView"
        :title="$t('OrderCurrent.sidebar.delete_custom_view')"
        @close-request="modal.deleteCustomView = false; clear()"

        closable >

        <div class="container-fluid">
          <div class="row">
            <regular-select
            :value="selectedCustomView"
            @change="selectedCustomView = $event"
            :placeholder="$t('OrderCurrent.modal.custom_view')" class="col-12 form-group">
              <option v-for="(view, index) in customViews" :key="index" :value="view['.key']">{{view.query.name}}</option>
            </regular-select>
            <div class="col-12">
              <div class="pull-right">
                <button class="btn btn-kne-orange" :disabled="selectedCustomView === ''" @click="deleteCustomView()">
                  {{$t('OrderCurrent.modal.confirm')}}
                </button>
                <button class="btn btn-danger" @click="modal.deleteCustomView = false">
                  {{$t('OrderCurrent.modal.cancel')}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </modal>

    </transition>

    <short-dispatch-modal
      v-if="isShortDispatchModal"
      ref="shortDispatchModal"
      :arrOfOrder="selectedFull"
      :liste="liste"
      :addressbook="addressbook"
      :priceOrderLink="priceOrderLink"
      :isOpen="isShortDispatchModal"
      :isOrderNbClickable="true"
      @closeModal="isShortDispatchModal = false; clear()"
      @clearSelected="clearSelected"
    />

    <status-change-modal
      v-if="isStatusEdit"
      ref="shortDispatchModal"
      :arrOfOrder="selectedFull"
      :isOpen="isStatusEdit"
      :priceOrderLink="priceOrderLink"
      @closeModal="isStatusEdit = false; clear()"
      @clearSelected="clearSelected"
    />

  </div>
</template>

<script>
import Modal from '../module/interface-components/Modal.vue'
import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
import regularDatalistDriver from '../module/basic-components/regularDatalistDriver.vue'
import regularTextarea from '../module/basic-components/regularTextarea.vue'
import regularSelect from '../module/basic-components/regularSelect.vue'
import regularInputNumber from '../module/basic-components/regularInputNumber.vue'
import regularInputNoSpecial from '../module/basic-components/regularInputNoSpecial.vue'
import HoverToolTip from '../module/basic-components/HoverToolTip.vue'
import Search from '../module/special-components/Other-components/Search.vue'
import TicketButton from '../module/interface-components/TicketButton.vue'
import TableElement from '../module/special-components/Table-component/Table-Element.vue'
import NewOrderModal from '../module/special-components/Modal-templates/NewOrder-modal.vue'
import ShortDispatchModal from '../module/special-components/Modal-templates/ShortDispatch-modal.vue'
import StatusChangeModal from '../module/special-components/Modal-templates/StatusChange-modal.vue'
import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
import CustomDatePick from '../module/special-components/Custom-packages/Custom-DatePick.vue'
import CustomJsonExcel from '../module/special-components/Custom-packages/Custom-JsonExcel.vue'
import CreateNote from '../module/special-components/Other-components/CreateNote.vue'

import {db} from '../../firebase'
import JsonExcel from 'vue-json-excel'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import SidebarToggleButton from '../module/interface-components/sidebarToggleButton.vue'
import ChatPage from '../module/interface-components/ChatPage.vue'
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import DeliveryLocationDetails from '../module/special-components/Other-components/DeliveryLocationDetails.vue'
import DatePick from 'vue-date-pick'
import 'vue-date-pick/dist/vueDatePick.css'
import OrderStatusCounter from '../module/special-components/Other-components/OrderStatusCounter.vue'

export default {
  name: 'orderCurrent',
  components: {
    LoadingRender,
    Modal,
    regularCheckbox,
    regularTextarea,
    regularSelect,
    regularInputNumber,
    regularInputNoSpecial,
    HoverToolTip,
    Search,
    regularDatalistDriver,
    JsonExcel,
    vueDropzone: vue2Dropzone,
    SidebarToggleButton,
    ChatPage,
    VueGoogleAutocomplete,
    DeliveryLocationDetails,
    DatePick,
    OrderStatusCounter,
    TicketButton,
    TableElement,
    NewOrderModal,
    ShortDispatchModal,
    StatusChangeModal,
    CustomDatePick,
    CustomJsonExcel,
    CreateNote
  },

  data () {
    return {
      customers_fields: {
        'Order': 'order',
        'Ref': 'numRef',
        'Source': 'source',
        'VIN': 'vin',
        'Date': {
          field: 'creationDate',
          callback: (value) => {
            return this.getDate(value)
          }
        },
        'Pick': 'transmitterName',
        'Drop': 'receiverName',
        'Billing': 'payerName',
        'Status': 'status',
        'Driver': 'driverName',
        'Province pick': 'provincePick',
        'Province drop': 'provinceDrop',
        'Remark': 'comment'
      },
      billingFields: { // For accounts that are not sageOne/sageID
        'Order': 'Order',
        'Ref': 'Ref',
        'Item': 'Item',
        'Date': 'Date',
        'Price': 'Price',
        'Description': 'Description',
        'Billing': 'Billing',
        'ToBeEmailed': 'ToBeEmailed',
        'Driver': 'Driver',
        'Tax': 'Tax'
      },
      VIN: '',
      MAKE: '',
      MODEL: '',
      YEAR: '',
      SIZE: '',
      vehicles: [],
      pricingAndDelay: [],
      vinsList: [],
      pickupSave: false,
      deliverySave: false,
      billingSame: false,
      order: {
        comment: '',
        docs: '',
        datePromis: '',
        dateExpected: '',
        dateSignataire: '',
        signataire: '',
        latitude: 0.001,
        longitude: 0.001,
        fuelCharge: 0,
        make: '',
        model: '',
        nbDispatch: 0,
        numRef: '',
        payer: '',
        payerAddress: '',
        payerCity: '',
        payerContact: '',
        payerFax: '',
        payerName: '',
        payerPhone: '',
        payerEmail: '',
        payerPostcode: '',
        payerCountry: '',
        payerProvince: '',
        billNum: '',
        receiver: '',
        receiverAddress: '',
        receiverCity: '',
        receiverContact: '',
        receiverFax: '',
        receiverName: '',
        receiverLat: 0,
        receiverLong: 0,
        receiverPhone: '',
        receiverEmail: '',
        receiverPostcode: '',
        receiverCountry: '',
        receiverProvince: '',
        receiverPlaceId: '',
        status: 'Processing',
        source: '',
        sageID: '',
        transmitter: '',
        transmitterAddress: '',
        transmitterCity: '',
        transmitterContact: '',
        transmitterFax: '',
        transmitterLat: 0,
        transmitterLong: 0,
        transmitterName: '',
        transmitterPhone: '',
        transmitterEmail: '',
        transmitterPostcode: '',
        transmitterCountry: '',
        transmitterProvince: '',
        transmitterPlaceId: '',
        transpCigle: '',
        transpName: '',
        vin: '',
        year: '',
        size: '',
        regularPrice: 0,
        price: 0,
        discount: 0,
        surplus: 0
      },
      datalist: {
        pickup: '',
        pickupUid: '',
        delivery: '',
        deliveryUid: '',
        billing: '',
        billingUid: ''
      },
      fields: {
        '.key': '',
        numRef: '',
        source: '',
        vin: '',
        datePromis: '',
        dateSignataire: '',
        docs: '',
        creationDate: '',
        receiverName: '',
        transmitterName: '',
        payerName: '',
        status: '',
        driverName: ''
      },
      backup: {
        sageIDDelivery: ''
      },
      filterResults: [],
      processing: [],
      addressbook: [],
      makeList: ['Acura', 'Alfa Romeo', 'AM General', 'AMC', 'Aston Martin', 'Audi', 'Bentley', 'BMW', 'Bugatti', 'Buick', 'Cadillac', 'Chevrolet', 'Chrysler', 'Daewoo', 'Daihatsu', 'Datsun', 'DeLorean', 'Dodge', 'Eagle', 'Ferrari', 'FIAT', 'Fisker', 'Ford', 'Genesis', 'Geo', 'GMC', 'Honda', 'HUMMER', 'Hyundai', 'INFINITI', 'Isuzu', 'Jaguar', 'Jeep', 'Karma', 'Kia', 'Lamborghini', 'Land Rover', 'Lexus', 'Lincoln', 'Lotus', 'Maserati', 'Maybach', 'Mazda', 'McLaren', 'Mercedes-Benz', 'Mercury', 'Merkur', 'MINI', 'Mitsubishi', 'Nissan', 'Oldsmobile', 'Panoz', 'Pininfarina', 'Plymouth', 'Pontiac', 'Porsche', 'Ram', 'Renault', 'Rolls-Royce', 'Saab', 'Saturn', 'Scion', 'Smart', 'Sterling', 'Subaru', 'Suzuki', 'Tesla', 'Toyota', 'Volkswagen', 'Volvo', 'Yugo'],
      selected: [],
      selectedWithOrderNo: [],
      selectedFull: [],
      selectedFull2: [],
      billing: false,
      dispatch: false,
      vinPrinting: false,
      shortDispatch: false,
      quickEdit: false,
      dispatchOrder: {
        chauffeur: '',
        chauffeurName: ''
      },
      modal: {
        newCustomView: false,
        deleteCustomView: false
      },
      newCustomView: {
        name: '',
        VIN: '',
        referenceNumber: '',
        source: '',
        pickup: '',
        delivery: '',
        billing: '',
        status: '',
        dateReceptionMin: '',
        dateReceptionMax: '',
        driver: '',
        afterXDays: '',
        beforeXDays: '',
        provincePick: '',
        provinceDrop: ''
      },
      customViews: [],
      selectedCustomView: '',
      autocompleteSearchFields: ['address_components', 'adr_address', 'formatted_address', 'formatted_phone_number', 'geometry', 'id', 'name', 'place_id', 'type', 'vicinity'],
      // 'utc_offset_minutes', 'url', 'photo', 'business_status', 'icon', 'scope', 'alt_id',
      badVin: false, // New Order, invalid VIN check
      vueGoogleAutocomplete: false,
      addressBookSearch: true,
      priceOrderLink: [], // This is to create a price/order link list for dispatches
      feedbackMessage: '',
      areAllOrdersSelected: false,
      selectedContactEmails: [],
      isNewOrderModal: false,
      isDistributedModal: false,
      isDeliveryLocationModal: false,
      isStatusEdit: false,
      selectedOrder: {}, // For changing date in Short Dispatch
      isShortDispatchModal: false,
      fieldsObj: [
       {
         text: `<i class="fa fa-solid fa-clipboard" />`,
         mobileTest: this.$t('OrderCurrent.survey'),
         type: 'survey',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.order'),
         type: '.key',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.reference'),
         type: 'numRef',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.VIN'),
         type: 'vin',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.modal.carInfo.model'),
         type: 'model',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.pickup'),
         type: 'transmitterName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.delivery'),
         type: 'receiverName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.billing'),
         type: 'payerName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.status'),
         type: 'status',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.driver'),
         type: 'driverName',
         value: ''
       }
      ],
      fieldsObjBIL: [
       {
         text: this.$t('OrderCurrent.order'),
         type: 'orderNumber',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.payer'),
         type: 'payerName',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.reference'),
         type: 'numRef',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.sageID'),
         type: 'sageID',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.price'),
         type: 'price',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.fuel_charge'),
         type: 'fuelCharge',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.taxes'),
         type: 'taxes',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.taxescomment'),
         type: 'taxesComment',
         value: ''
       },
       {
         text: this.$t('OrderCurrent.billingDate'),
         type: 'billingDate',
         value: ''
       }],
      fieldsObjEDI: [
        {
         text: this.$t('OrderCurrent.order'),
         type: 'orderNumber',
         value: ''
        },
        {
         text: this.$t('OrderCurrent.source'),
         type: 'source',
         value: ''
        },
        {
         text: this.$t('OrderCurrent.reference'),
         type: 'numRef',
         value: ''
        },
        {
         text: this.$t('OrderCurrent.reason'),
         type: 'note',
         value: ''
        }
      ],
      fieldsObjVIN: [
        {
         text: this.$t('OrderCurrent.order'),
         type: 'orderNumber',
         value: ''
        },
        {
         text: this.$t('OrderCurrent.VIN'),
         type: 'VIN',
         value: ''
        }
      ],
      spreadDate: ''
    }
  },

  created () {
    this.isLoading = true
    this.$store.state.isSidebarOpen = false

    this.$bindAsArray('processing', db.ref('database/transporter/' + this.companyUID + '/deliveries/'), null, () => {
      this.isLoading = false
    })

    this.$bindAsArray('liste', db.ref('database/transporter/' + this.companyUID + '/liste'))
    this.$bindAsArray('pending', db.ref('database/transporter/' + this.companyUID + '/unprocessed')) // [DEV] UNCOMMENT ON PROD
    this.$bindAsArray('customViews', db.ref('database/transporter/' + this.companyUID + '/customViews'))
    this.$bindAsObject('user', db.ref(`userInfos/${this.companyUID}/${this.uid}`))
    if (this.$route.query.newOrder) this.loadAddressBook()
  },

  methods: {
    updateDatePick (date) {
      date = this.formatDate(date)
      this.spreadDate = date
    },

    clearSelected () {
      this.selected = []
    },

    updateSelectedOrders (selected) {
      this.selected = selected
    },

    updateFilterResults (sortResults) {
      this.filterResults = sortResults
    },

    onOpenShortDispatchModal () {
      this.isShortDispatchModal = true
    },

    clearfeedbackMessage () {
      this.feedbackMessage = ''
    },

    deleteCustomView () {
      db.ref('database/transporter/' + this.companyUID + '/customViews').child(this.selectedCustomView).set(null).then(() => {
        this.modal.deleteCustomView = false
        this.selectedCustomView = ''
      }).catch((error) => {
        console.log(error)
      })
    },

    // Print a list of VINs
    sendToPrint () {
      // Pass the element id here
      this.$htmlToPaper('vinPrint')
      this.clearSelected()
    },

    daysBetweenNow (date1) {
      var oneDay = 24 * 60 * 60 * 1000
      var firstDate = new Date(date1)
      var secondDate = new Date()
      var diffDays2 = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)))
      return diffDays2
    },

    calcBusinessDays (start2) {
      // This makes no effort to account for holidays
      // Counts end day, does not count start day

      // make copies we can normalize without changing passed in objects
      var start = new Date(start2)
      var end = new Date()

      // initial total
      var totalBusinessDays = 0

      // normalize both start and end to beginning of the day
      start.setHours(0, 0, 0, 0)
      end.setHours(0, 0, 0, 0)

      var current = new Date(start)
      current.setDate(current.getDate() + 1)
      var day
      // loop through each day, checking
      while (current <= end) {
        day = current.getDay()
        if (day >= 1 && day <= 5) {
          ++totalBusinessDays
        }
        current.setDate(current.getDate() + 1)
      }
      return totalBusinessDays
    },

    calcBusinessDays2 (start2) {
      // This makes no effort to account for holidays
      // Counts end day, does not count start day

      // make copies we can normalize without changing passed in objects
      var start = new Date()
      var end = new Date(start2)

      // initial total
      var totalBusinessDays = 0

      // normalize both start and end to beginning of the day
      start.setHours(0, 0, 0, 0)
      end.setHours(0, 0, 0, 0)

      var current = new Date(start)
      current.setDate(current.getDate() + 1)
      var day
      // loop through each day, checking
      while (current <= end) {
        day = current.getDay()
        if (day >= 1 && day <= 5) {
          ++totalBusinessDays
        }
        current.setDate(current.getDate() + 1)
      }
      return totalBusinessDays
    },

    checkDate (date1) {
      var firstDate = new Date(date1)
      var secondDate = new Date()
      if (firstDate <= secondDate) {
        return true
      } else {
        return false
      }
    },

    addCustomView () {
      let nv = this.newCustomView
      let custom = {
        query: {
          name: nv.name,
          customView: true
          }
        }

      if (nv.VIN !== '') custom.query.vin = nv.VIN
      if (nv.referenceNumber !== '') custom.query.reference = nv.referenceNumber
      if (nv.source !== '') custom.query.source = nv.source
      if (nv.pickup !== '') custom.query.pickup = nv.pickup
      if (nv.delivery !== '') custom.query.delivery = nv.delivery
      if (nv.dateReceptionMin !== '') custom.query.from = Date.parse(nv.dateReceptionMin)
      if (nv.dateReceptionMax !== '') custom.query.to = Date.parse(nv.dateReceptionMax)
      if (nv.status !== '') custom.query.status = nv.status
      if (nv.billing !== '') custom.query.billing = nv.billing
      if (nv.driver !== '') custom.query.driver = nv.driver
      if (nv.afterXDays !== '') custom.query.after = parseInt(nv.afterXDays)
      if (nv.beforeXDays !== '') custom.query.before = parseInt(nv.beforeXDays)
      if (nv.provincePick !== '') custom.query.provincePick = nv.provincePick
      if (nv.provinceDrop !== '') custom.query.provinceDrop = nv.provinceDrop

      for (const property in custom.query) {
        if (Object.hasOwnProperty.call(custom.query, property)) {
          let element = custom.query[property]
          if (typeof element === 'string' || element instanceof String) {
            let strippedElement = element.trim() // Remove whitespace on left and right side
            custom.query[property] = strippedElement
          }
        }
      }

      // return
      db.ref('database/transporter/' + this.companyUID + '/customViews').push().set(custom).then(() => {
        this.modal.newCustomView = false
        this.clear()
      }).catch((error) => {
        console.log(error)
      })
    },

    goToCustomView (to) {
      this.$router.go(to)
    },

    applyBillingDateToAll (date) {
      this.selectedFull.forEach((element) => {
        element.billingDate = date
      })
    },

    checkSelectedOrdersLength () {
      if (this.selected.length > 1) {
        this.feedbackMessage = this.$t('OrderCurrent.modal.dispatch.only_one_order')
        return
      } else {
        this.dispatch = true
        this.feedbackMessage = ''
      }
    },

    // Save billing as SageId Account
    saveBilling () {
      this.selectedFull.forEach((element, index) => {
        db.ref('database').child('transporter').child(this.companyUID).child('deliveries').child(element.orderNumber).update({'price': element.price, 'taxes': element.taxes, 'fuelCharge': element.fuelCharge, 'taxesComment': element.taxesComment, 'billingDate': element.billingDate}).then(() => {
          // ======================== ADD FAST BILLING LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'FAST_BILLING', 'orderID': element.orderNumber, 'date': Date.now()})
          // ======================== ADD FAST BILLING LOG =======================
        })
      })

      this.billing = false
      this.selectedFull = []
      this.clearSelected()
    },

    async onSaveBillingOrder () {
      this.billing = false
      await this.selectedFull.forEach((element, index) => {
        db.ref('database')
        .child('transporter')
        .child(this.companyUID)
        .child('deliveries')
        .child(element.orderNumber)
        .update({'price': element.price, 'taxes': element.taxes, 'fuelCharge': element.fuelCharge, 'taxesComment': element.taxesComment, 'billingDate': element.billingDate}).then(() => {
          // ======================== ADD FAST BILLING LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'FAST_BILLING', 'orderID': element.orderNumber, 'date': Date.now()})
          // ======================== ADD FAST BILLING LOG =======================
        })
      })

      this.openBilling()
    },

    onFinishBilling () {
      this.selectedFull.forEach(async (element, index) => {
        let orderId = element.orderNumber

        await db.ref('database').child('transporter').child(this.companyUID).child('deliveries').child(orderId).update({'status': 'Terminée'}).then(() => {
          // ======================== ADD FAST BILLING LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'FAST_BILLING', 'orderID': orderId, 'date': Date.now()})
          // ======================== ADD FAST BILLING LOG =======================
        })
      })

      this.billing = false
      this.selectedFull = []
      this.selectedFull2 = []
      this.clearSelected()
    },

    onQuickEditAction () {
      this.selectedFull.forEach((element, index) => {
        const orderId = element.orderNumber
        const noteObj = {
          date: Date.now(),
          text: element.note,
          name: this.setNoteName(this.user)
        }

        this.saveOrdersFirebase(orderId, element, noteObj)
      })

      this.quickEdit = false
      this.selectedFull = []
      this.clearSelected()
    },

    saveOrdersFirebase (orderId, element, noteObj) {
      if (!this.checkIsUndefined(element.note)) db.ref('database/transporter/' + this.companyUID + '/deliveries/' + orderId + '/notes/').push(noteObj) // Save if element.note is not undefined

      db.ref('database').child('transporter').child(this.companyUID).child('deliveries').child(orderId).update({'source': element.source, 'numRef': element.numRef}).then(() => {
        // ======================== ADD FAST BILLING LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'QUICK_EDIT', 'orderID': orderId, 'date': Date.now()})
      })
    },

    setNoteName (user) {
      const isFirstNameValid = (typeof user.firstName !== 'undefined' && user.firstName !== '')
      const isLastNameValid = (typeof user.lastName !== 'undefined' && user.lastName !== '')

      if (!isFirstNameValid || !isLastNameValid) return this.$store.state.userInfo.name
      else return `${user.firstName} ${user.lastName}`
    },

    openStatusEdit () {
      this.fetchSelected('DISPATCH')
      this.isStatusEdit = true
    },

    openNewOrder () {
      this.loadAddressBook()
      this.isNewOrderModal = true
    },

    openBilling () {
      this.fetchSelected('BILLING')

      this.billing = true
    },

    openQuickEdit () {
      this.fetchSelected('QUICKEDIT')
      this.quickEdit = true
    },

    openDispatch () {
      this.fetchSelected('DISPATCH')
      this.loadAddressBook()
      this.onOpenShortDispatchModal()
    },

    openVinPrinting () {
      this.fetchSelected()
      this.vinPrinting = true
    },

    fetchSelected (action) {
      this.selectedFull = []
      this.selectedFull2 = []
      this.priceOrderLink = []

      let selectedReversed = [...this.selected]
      selectedReversed.reverse()

      selectedReversed.forEach((orderId) => {
        db.ref('database').child('transporter').child(this.companyUID).child('deliveries').child(orderId).once('value').then((snap) => {
          const selectedFull = this.selectedFull
          const selectedFull2 = this.selectedFull2
          const orderData = snap

          this.setDataFromFetch(selectedFull, selectedFull2, orderData)

          if (action === 'BILLING') this.setFuelCharge()
          if (action === 'DISPATCH' || (action === 'BILLING' && !orderData.val().price)) {
            this.$set(selectedFull[selectedFull.length - 1], 'price', '') // Why?
            if (action === 'DISPATCH') {
              this.setPriceOrderLink(orderId, orderData.val())
              this.$set(selectedFull[selectedFull.length - 1], 'comment', 'Client/Customer: ' + orderData.val().payerName)
              if (this.userInfo.driverComment) selectedFull[selectedFull.length - 1].comment += '\n' + orderData.val().comment
            }
          }

          if (!orderData.val().taxes) this.$set(selectedFull[selectedFull.length - 1], 'taxes', '')
          if (!orderData.val().taxesComment) this.$set(selectedFull[selectedFull.length - 1], 'taxesComment', '')
          if (!orderData.val().transmitterCountry) this.$set(selectedFull[selectedFull.length - 1], 'transmitterCountry', '')
          if (!orderData.val().receiverCountry) this.$set(selectedFull[selectedFull.length - 1], 'receiverCountry', '')
          if (!orderData.val().billingDate) this.$set(selectedFull[selectedFull.length - 1], 'billingDate', this.formatDate(Date.now()))
          this.order = JSON.parse(JSON.stringify(selectedFull[0]))
        })
      })
    },

    setDataFromFetch (selectedFull, selectedFull2, orderData) {
      this.$set(selectedFull, selectedFull.length, orderData.val())
      this.$set(selectedFull[selectedFull.length - 1], 'orderNumber', orderData.key) // Used in other functions, be careful changing the 'orderNumber' variable name

      this.$set(selectedFull[selectedFull.length - 1], 'billOrderNumber', 'QB' + orderData.key) // For billingFields excel sheet generation
      this.$set(selectedFull[selectedFull.length - 1], 'fromToBilling', orderData.val().make + ' ' + orderData.val().model + ' ' + orderData.val().year + ' - VIN: ' + orderData.val().vin + ' ' + orderData.val().transmitterName + ' to ' + orderData.val().receiverName)

      const obj = { // For accounts that are not sageOne/sageID
        'Order': 'QB' + orderData.key,
        'Item': 'Sales',
        'Ref': orderData.val().numRef,
        'Date': orderData.val().billingDate,
        'Price': orderData.val().price,
        'Description': orderData.val().make + ' ' + orderData.val().model + ' ' + orderData.val().year + ' - VIN: ' + orderData.val().vin + ' ' + orderData.val().transmitterName + ' to ' + orderData.val().receiverName + ' Shipped to : ' + orderData.val().receiverProvince,
        'Billing': orderData.val().payerName,
        'Driver': orderData.val().driverName,
        'ToBeEmailed': true,
        'Tax': 'H'
      }

      const obj2 = { // For accounts that are not sageOne/sageID
        'Order': 'QB' + orderData.key,
        'Ref': orderData.val().numRef,
        'Item': 'Fuel Surcharge',
        'Date': orderData.val().billingDate,
        'Price': (Number(orderData.val().price) * Number(this.$store.state.userInfo.fuelCharge)) / 100,
        'Description': orderData.val().fuelCharge + '%',
        'Billing': orderData.val().payerName,
        'Driver': ' ',
        'ToBeEmailed': true,
        'Tax': 'H'
      }

      this.$set(selectedFull2, selectedFull2.length, obj)
      this.$set(selectedFull2, selectedFull2.length, obj2)
    },

    /** Sets the fuel charge for each order as the @store info */
     // If the order doesn't have a fuel charge, set it to the on of the account
    setFuelCharge () {
      this.selectedFull.forEach(element => {
        let fuelCharge = element.fuelCharge
        if (!fuelCharge || fuelCharge === '') element.fuelCharge = this.$store.state.userInfo.fuelCharge
        else console.log('Elsed', this.$store.state.userInfo.fuelCharge)
      })
    },

    setPriceOrderLink (element, orderInfo) {
      let priceObj = {
        orderId: element,
        price: orderInfo.price,
        orderInfo: orderInfo
      }

      this.priceOrderLink.push(priceObj)
    },

    loadAddressBook () {
      console.log('Initializing addressbook')
      db.ref('database/transporter/' + this.companyUID + '/carnet').once('value').then((snap) => {
        let addressbookArray = []
        snap.forEach((element) => {
          let item = element.val()
          item.key = element.key
          addressbookArray.push(item)
        })

        this.addressbook = addressbookArray
      })
    },

    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },

    formatDate (date) {
      let fdate = new Date(date)
      fdate = fdate.getFullYear() + '-' + ('0' + (fdate.getMonth() + 1)).slice(-2) + '-' + ('0' + fdate.getUTCDate()).slice(-2)

      return fdate
    },

    print: function (order) {
      if (!order.isPrinted) {
        // db.ref('test2/transporter/' + this.companyUID + '/deliveries/' + order['.key']).update({'isPrinted': true})
        db.ref('database/transporter/' + this.companyUID + '/deliveries/' + order['.key']).update({'isPrinted': true})
      }
    },

    clear: function () {
      for (let attr in this.order) {
        this.order[attr] = ''
      }
      this.clearfeedbackMessage()
      this.dispatchOrder.chauffeur = ''
      this.dispatchOrder.chauffeurName = ''
      this.order.regularPrice = 0
      this.order.price = 0
      this.order.discount = 0
      this.order.surplus = 0
      this.order.status = 'Processing'
      this.order.latitude = 0.001
      this.order.longitude = 0.001
      this.order.nbDispatch = 0
      for (let attr in this.datalist) {
        this.datalist[attr] = ''
      }
      this.vehicles = []
      this.VIN = ''
      this.MAKE = ''
      this.MODEL = ''
      this.YEAR = ''
      this.SIZE = null // Car size check
      this.badVin = false // Valid vin check
      for (let attr in this.newCustomView) {
        this.newCustomView[attr] = ''
      }
      this.isNewOrderModal = false
    },

    shortenString (text) {
      if (typeof text === 'undefined') return text
      else {
        let subString = text.substring(0, 22)
        if (text.length > 22) subString += '...'
        return subString
      }
    },

    getOrderHistoryLength (order) {
      const orderObj = order
      let counter = 0

      for (const key in orderObj.historySync) {
        if (Object.hasOwnProperty.call(orderObj.historySync, key)) {
          counter++
        }
      }
      return counter.toString()
    },

    dispatchHistToolTip (order) {
      let text = this.$t('OrderCurrent.dispatch_history_tooltip')

      let orderInfoText = ''

      if (order.historySync) {
        for (const key in order.historySync) {
          if (Object.hasOwnProperty.call(order.historySync, key)) {
            orderInfoText += `${order.historySync[key].transmitterAddress}, ${order.historySync[key].transmitterCity}, ${order.historySync[key].transmitterProvince} -> ${order.historySync[key].receiverAddress}, ${order.historySync[key].receiverCity}, ${order.historySync[key].receiverProvince}, ${order.historySync[key].price || order.historySync[key].prix || 0}$ <br>`
          }
        }
        text = `<strong> ${text} </strong> <br> ${orderInfoText}`
        return text
      }

      return ''
    },

    getOrderNotes (orderNotes) {
      let text = this.$t('OrderCurrent.notes')

      if (orderNotes) {
        for (const key in orderNotes) {
          if (Object.hasOwnProperty.call(orderNotes, key)) {
            const element = orderNotes[key]
            text += `<br> ${element.text} `
          }
        }
      }
      return text
    },

    getOrderSurvey (orderSurvey) {
      let text = '<strong>' + this.$t('Survey.text') + ' </strong> <br>'

      if (orderSurvey) {
        for (const key in orderSurvey) {
          if (Object.hasOwnProperty.call(orderSurvey, key)) {
            const element = orderSurvey[key]
            element.forEach(question => {
              let dateTime = ''
              let openCloseTime = ''

              if (question.dateTime) dateTime = '| ' + this.translateDateTime(question.dateTime)
              if (question.openTime && question.closeTime) openCloseTime = ` | ${this.$t('OrderCurrent.open')}: ${question.openTime} / ${this.$t('OrderCurrent.close')}: ${question.closeTime}`
              text += `<br> ${this.$t(`Survey.question_${question.id}`)} ${this.translateSurveyAnswer(question.answer)} ${dateTime} ${openCloseTime}<br>`
            })
          }
        }
      }

      return text
    },

    translateDateTime (answer) {
      let answerArr = answer.split(',')
      let string = ''

      answerArr.forEach(id => {
        string += this.$t(`Survey.date_${id}`) + ' '
      })

      return string
    },

    translateSurveyAnswer (answer) {
      if (answer === true) return this.$t('General.yes')
      else if (answer === false) return this.$t('General.no')
      else return answer
    },

    getSurveyIconColor (survey) {
      let color = ''
      let colorGreen = 'rgb(3, 115, 3)'
      let colorRed = 'red'

      if (survey) {
        for (const key in survey) {
          if (Object.hasOwnProperty.call(survey, key)) {
            survey[key].forEach(question => {
              if (question.id === '1') color = colorGreen
              if (question.id === '1.1') {
                let time = this.getTimestamp(question.answer)
                if (time > Date.now()) color = colorRed
                else if (time < Date.now()) color = colorGreen
              }
            })
          }
        }
      }

      return color
    },

    getTimestamp (receivedDate) {
      let timestamp = Date.parse(receivedDate)
      return timestamp
    }
  },

  computed: {
    checkUpdateKey () {
      if (this.updateKey) return true
      else return false
    },

    computed_newCount (newCount) {
      return newCount
    },

    formCompleted: function () {
      var order = this.order
      return (
        this.vehicles.length !== 0 &&
        order.receiverName !== '' &&
        order.receiverAddress !== '' &&
        order.receiverCountry !== '' &&
        order.receiverCity !== '' &&
        order.receiverPostcode !== '' &&
        order.receiverProvince !== '' &&
        order.payerName !== '' &&
        order.payerAddress !== '' &&
        order.payerCountry !== '' &&
        order.payerCity !== '' &&
        order.payerPostcode !== '' &&
        order.payerProvince !== '' &&
        order.transmitterName !== '' &&
        order.transmitterAddress !== '' &&
        order.transmitterCountry !== '' &&
        order.transmitterCity !== '' &&
        order.transmitterPostcode !== '' &&
        order.transmitterProvince !== '' &&
        ((this.isSageOne && order.price !== '') || !this.isSageOne))
    },
    sageOneCheck () {
      return ((this.$store.state.userInfo.isSageOne && this.order.sageID !== '' && this.order.sageID !== undefined) || !this.$store.state.userInfo.isSageOne)
    },
    allOrderID () {
      var orderIDs = ''
      this.selected.forEach((element, index) => {
        index !== 0 ? orderIDs += '+' + element : orderIDs += element
      })
      return orderIDs
    },
    allBillingFieldCompleted () {
      var result = true

      this.selectedFull.forEach((element) => {
        if (element.taxes === '' || element.price === '' || element.taxes === undefined || element.price === undefined || element.sageID === '' || element.sageID === undefined) result = false
      })

      return result
    },
    dispatchFormFilled () {
      return this.dispatchOrder.chauffeur !== '' &&
        this.order.transmitterName !== '' &&
        this.order.transmitterAddress !== '' &&
        this.order.transmitterCountry !== '' &&
        this.order.transmitterCity !== '' &&
        this.order.transmitterPostcode !== '' &&
        this.order.transmitterProvince !== '' &&
        this.order.receiverName !== '' &&
        this.order.receiverAddress !== '' &&
        this.order.receiverCountry !== '' &&
        this.order.receiverCity !== '' &&
        this.order.receiverPostcode !== '' &&
        this.order.receiverProvince !== ''
    },
    companyUID () {
      return this.$store.state.authorization.company
    },
    uid () {
      return this.$store.state.user.uid
    },
    sageIDonly () {
      return this.addressbook.filter(customer => customer.sageID)
    },
    hasProvince () {
      return this.addressbook.filter(customer => customer.province && customer.city && customer.country)
    },
    isSageOne () {
      return this.$store.state.userInfo.isSageOne
    },
    isQuickBook () {
      return this.$store.state.userInfo.isQuickbook
    },
    userInfo () {
      return this.$store.state.userInfo
    },
    hasIntegration () {
      return this.$store.state.userInfo.hasIntegration
    },
    isDateRoute () {
      return this.$route.query.newDate
    },
    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    }
  },

  watch: {
    billingSame: function (val) {
      var order = this.order
      if (!val) {
        order.payerAddress = ''
        order.payerCity = ''
        order.payerContact = ''
        order.payerFax = ''
        order.payerName = ''
        order.payerPhone = ''
        order.payerEmail = ''
        order.payerPostcode = ''
        order.payerProvince = ''
        order.payerCountry = ''
        order.sageID = ''
      } else {
        order.payerAddress = order.receiverAddress
        order.payerCity = order.receiverCity
        order.payerContact = order.receiverContact
        order.payerFax = order.receiverFax
        order.payerName = order.receiverName
        order.payerPhone = order.receiverPhone
        order.payerEmail = order.receiverEmail
        order.payerPostcode = order.receiverPostcode
        order.payerProvince = order.receiverProvince
        order.payerCountry = order.receiverCountry
        order.sageID = this.backup.sageIDDelivery || ''
        this.datalist.billing = ''
        this.datalist.billingUid = ''
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .dispatch-info-tab {
    display: flex;
    flex-flow: row;
  }
  .table thead th{
    border-bottom: 1px solid #eceeef;
    border-top: none;
  }
  #addOrder, #customView{
    position: relative;
  }

  .printed{
    background-color: #79cc79 !important;
    border-color: #79cc79 !important;
  }
  .kne-tab:hover{
    color: #f7941e !important;
  }
  .kne-tab.active{
    color: #f7941e !important;
  }
  th{
    resize: horizontal;
  }
  .view{
    padding-left: 11rem;
  }
  .sidebar{
    width: 10.5rem;
  }
  .current{
    border-left: 3px solid #f7941e;
  }
  #checkBox{
    width: 1.25rem;
    height: 1.25rem;
  }
  #fileIcon{
    margin-top: 0.70rem;
  }

  .fa-exclamation{
    margin-left: 0.25rem;
  }

  .input--missing {
    border: solid 1px;
    border-color: rgb(211, 116, 116);
    border-radius: 5px;
  }

  .toggleSwitch {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #priceSection label {
    margin-left: 1rem;
  }

  .newOrder__container--display {
    display: flex;
    flex-flow: row;
    width: 50%;
  }

  .newOrder__container--display-mobile {
    display: flex;
    flex-flow: column;
    width: 100%;
  }

  .document-date__container {
    display: flex;
    justify-content: space-between;
  }

  .document-date__container--mobile {
    flex-direction: column;
  }

  .document-date__item {
    width: 45%;
  }

  .document-date__item--mobile {
    width: 100%;
  }

  .document-date__button-red {
    background-color: rgb(255, 58, 58);
  }
  .icon-size {
    font-size: 1.5rem;
  }
  .flex-row {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
</style>
